import {motion, useAnimation} from "framer-motion";
import React, {useEffect, useState} from "react";
import "./index.less"
import "./indexMobile.less"
import Modal from 'react-modal';
import {isMobile} from "react-device-detect";

Modal.setAppElement('#root');

export default ({data, type = null}) => {
    const [isHover, setIsHover] = useState(false);
    const controls = useAnimation();
    const videoRef = React.useRef();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    const handleAfterLoad = (origin, destination, direction) => {

    };

    useEffect(() => {
        if(data == null){
            return;
        }

        if(isMobile){
            if (data.destination.anchor === 's4' || data.destination.anchor === 'bo2') {
                setIsHover(true);
            } else {
                setIsHover(false);
            }
        }
    }, [data])

    const variants = {
        hidden: {opacity: 0, x: -100, transition: {delay: 1}},
        visible: {opacity: 1, x: 0, transition: {duration: 0.5, delay: 1.3}},
    };

    const scaleVariants = {
        hidden: {scale: 0.6},
        visible: {scale: 1, transition: {duration: 0.5}}, // transition added here
    };

    const playScale = () => {
        controls.start("visible");
    }

    const playScaleHide = () => {
        controls.start("hidden");
    }

    const openModal = () => {
        if(isMobile){
            setShowVideo(true);
        }else{
            setIsOpen(true);
            window.fullpage_api.setAllowScrolling(false);
        }
    }

    const closeModal = () => {
        if(isMobile){
            setShowVideo(false);
        }else{
            setIsOpen(false);
            window.fullpage_api.setAllowScrolling(true);
        }
    }

    const pagePlayScale = () => {
        videoRef.current.currentTime = 5.7;
        videoRef.current.play();
        playScale();
    }

    useEffect(() => {
        if (data == null) {
            return;
        }

        if (type == null) {
            if (data.destination.anchor == "s4") {
                pagePlayScale();
            }

            if (data.destination.anchor != "s4") {
                if (data.direction == 'down') {
                    return;
                }
                const timer = setTimeout(() => {
                    playScaleHide();
                }, 1000);

                return () => clearTimeout(timer);
            }
        } else {
            if (data.destination.anchor == type) {
                pagePlayScale();
            }

            if (data.destination.anchor != type) {
                if (data.direction == 'down') {
                    return;
                }
                const timer = setTimeout(() => {
                    playScaleHide();
                }, 1000);

                return () => clearTimeout(timer);
            }
        }

    }, [data])

    return <>
        {!isMobile && <div className={"section"}>
            <motion.div
                className="VideoSection-container"
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                initial="hidden"
                animate={controls}
                variants={scaleVariants}
            >
                <video
                    ref={videoRef}
                    className="bg-video"
                    src="/video1.m4v"
                    autoPlay
                    muted
                    loop
                />
                <div className={"overlay-container"} onClick={openModal}>
                    <motion.div
                        className="overlay-content"
                        animate={isHover ? "visible" : "hidden"}
                        initial="hidden"
                        variants={variants}
                    >
                        <div>
                            <svg width="240" height="224" viewBox="0 0 240 224" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path
                                        d="M6.53472 108.479C3.73137 109.989 3.73137 114.011 6.53472 115.521L174.103 205.817C176.767 207.253 180 205.323 180 202.296L180 21.7044C180 18.6771 176.767 16.747 174.103 18.1831L6.53472 108.479Z"
                                        fill="white"/>
                                </g>
                                <path
                                    d="M6.53472 108.479C3.73137 109.989 3.73137 114.011 6.53472 115.521L174.103 205.817C176.767 207.253 180 205.323 180 202.296L180 21.7044C180 18.6771 176.767 16.747 174.103 18.1831L6.53472 108.479Z"
                                    fill="white"/>
                            </svg>
                            <span>播放</span>
                        </div>
                    </motion.div>

                    <motion.div
                        className="overlay-title"
                        animate={!isHover ? "visible" : "hidden"}
                        initial="visible"
                        variants={variants}
                    >
                        品牌短片
                    </motion.div>
                </div>
            </motion.div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    },
                    content: {
                        border: 'none',
                        background: 'transparent',
                        width: 'auto',
                        height: 'auto',
                        position: 'relative',
                        overflow: 'hidden'
                    }
                }}
            >
                <video
                    className="modal-video"
                    src="/video1.m4v"
                    controls
                    autoPlay
                />
            </Modal>

        </div>}

        {isMobile && <div className={"section"}>
            <motion.div
                className="VideoSection-container-mobile"
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                initial="hidden"
                animate={controls}
                variants={scaleVariants}
            >
                <video
                    ref={videoRef}
                    className="bg-video-mobile"
                    src="/video1.m4v"
                    playsInline={true}
                    autoPlay
                    muted
                    loop
                />
                <div className={"overlay-container-mobile"} onClick={openModal}>
                    <motion.div
                        className="overlay-content-mobile"
                        animate={isHover ? "visible" : "hidden"}
                        initial="hidden"
                        variants={variants}
                        style={{marginTop:"-5px"}}
                    >
                        <div>
                            <svg width="240" height="224" viewBox="0 0 240 224" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path
                                        d="M6.53472 108.479C3.73137 109.989 3.73137 114.011 6.53472 115.521L174.103 205.817C176.767 207.253 180 205.323 180 202.296L180 21.7044C180 18.6771 176.767 16.747 174.103 18.1831L6.53472 108.479Z"
                                        fill="white"/>
                                </g>
                                <path
                                    d="M6.53472 108.479C3.73137 109.989 3.73137 114.011 6.53472 115.521L174.103 205.817C176.767 207.253 180 205.323 180 202.296L180 21.7044C180 18.6771 176.767 16.747 174.103 18.1831L6.53472 108.479Z"
                                    fill="white"/>
                            </svg>
                            <div>播放</div>
                        </div>
                    </motion.div>

                    <motion.div
                        className="overlay-title-mobile"
                        animate={!isHover ? "visible" : "hidden"}
                        initial="visible"
                        variants={variants}
                    >
                        品牌短片
                    </motion.div>
                </div>
            </motion.div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    },
                    content: {
                        border: 'none',
                        background: 'transparent',
                        width: 'auto',
                        height: 'auto',
                        position: 'relative',
                        overflow: 'hidden'
                    }
                }}
            >
                <video
                    className="modal-video-mobile"
                    src="/video1.m4v"
                    controls
                    autoPlay
                />
            </Modal>

            {showVideo && isMobile && (
                <div className={"overlay"} onClick={closeModal}>
                    <div className={"videoPopup"} onClick={(e) => e.stopPropagation()}> {/* 阻止冒泡，确保点击视频本身时不会关闭 */}
                        <video controls autoPlay={true}>
                            <source src={"/video1.m4v"}/>
                            你的浏览器不支持 video 标签。
                        </video>
                    </div>
                </div>
            )}

        </div>}
    </>
}